const setFristChildrenPassportNo = (data = null) => {
  return {
    type: 'SET_FRISTCHILDRENPASSPORTNO',
    data
  }
}

export default {
  setFristChildrenPassportNo,
}
